import { Component, OnInit, ChangeDetectorRef, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatDividerModule } from '@angular/material/divider';
import { ParametresService } from 'src/app/services/parametres.service';
import { map, of, switchMap, take } from 'rxjs';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { CommunicationService } from 'src/app/shared/communication.service';
import { HistoriqueModificationsComponent } from './historique-modifications/historique-modifications.component';
import { ModalModifParametreComponent } from './modal-modif-parametre/modal-modif-parametre.component';
import { ImportParameterDataComponent } from './import-parameter-data/import-parameter-data.component';
import { Broadcast } from 'src/app/core/services/broadcast.service';
import { ExcelService } from 'src/app/core/services/excel.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-parametres',
  imports: [
    ArianeNavComponent,
    MatDividerModule,
    DataTableComponent,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    DataTableComponent
  ],
  templateUrl: './parametres.component.html',
  styleUrls: ['./parametres.component.scss']
})
export class ParametresComponent implements OnInit {
  arianeLabel: string = 'Paramètres de configuration';
  arianeIcon: string = 'settings_applications';
  pipe = new DatePipe('fr-FR'); // Use your own locale
  dataTable: any[] = [];
  keyChanges: any = {};
  untransformedData: any = [];
  dataLength: number;
  rowData: any[] = [];
  dataJSON: any[] = [];
  filterValue: string = '';
  filterInputValue = signal('');
  arianeList = [
    {
      label: 'Administration',
      url: '/pama/administration'
    },
    {
      label: 'Paramètres de configuration',
      url: '/pama/administration/parametres_de_configurations'
    }
  ];

  constructor(
    public parametresService: ParametresService,
    private refreshService: CommunicationService,
    public dialog: MatDialog,
    private detectorRef: ChangeDetectorRef,
    private broadcast: Broadcast,
    private excelService: ExcelService
  ) {}
  ParametresDisplayedColumns: string[] = ['Libellé', 'Propriété', 'Valeur', 'Description', 'Obligatoire', 'Actions'];

  ngOnInit() {
    //this.loadParameterList();
    this.updatePaginationParametres(null);
    this.refreshService.refreshList$.subscribe((refresh) => {
      if (refresh) {
        //this.loadParameterList();
        this.updatePaginationParametres(null);
      }
    });
  }

  onFilterInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.filterInputValue.set(value);
  }

  clearFilter(input: HTMLInputElement): void {
    this.filterInputValue.set('');
    input.value = '';
    input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
    input.focus();
  }

  retrieveHistory(id: number) {
    this.searchDataID(this.dataJSON, id);
    this.dialog.open(HistoriqueModificationsComponent, {
      width: '780px',
      data: {
        data: this.rowData
      }
    });
  }
  convertExcel(data: any, name: string) {
    const search = '/';
    const replaceWith = '-';
    const date = new Date().toLocaleDateString('en-GB').split(search).join(replaceWith);
    let fileName = `${name}${date}`;
    this.excelService.exportToExcel(data, `${fileName}.xlsx`, 'Sheet1');
  }
  exportParametre() {
    const currentFilter = this.filterValue ?? '';

    this.parametresService
      .getParametresWithParams(0, environment.pagination.limit, currentFilter)
      .pipe(
        take(1),
        switchMap((firstPage: any) => {
          if (!firstPage) {
            return of([]);
          }

          const firstPageResults = firstPage.results ?? [];
          const totalRecords = firstPage.totalRecords ?? firstPageResults.length;

          if (totalRecords <= firstPageResults.length) {
            return of(firstPageResults);
          }

          return this.parametresService
            .getParametresWithParams(0, totalRecords, currentFilter)
            .pipe(map((fullPage: any) => fullPage?.results ?? []));
        }),
        map((allResults: any[]) => {
          const transformedData = this.transformData(allResults);
          this.dataTable = transformedData;

          return transformedData.map(({ id, ...exportableData }) => exportableData);
        })
      )
      .subscribe((exportData) => {
        this.convertExcel(exportData, 'Export_Parametres_Configurations_');
      });
  }

  searchDataID(data: any, id: number) {
    let index = Object.keys(data).find((k) => data[k].id === id);

    if (index != null) {
      this.rowData = this.dataJSON[Number(index)];
    }
  }

  modifParametre(id: number) {
    this.searchDataID(this.dataJSON, id);

    const dialogRef = this.dialog.open(ModalModifParametreComponent, {
      width: '640px',
      disableClose: true,
      data: {
        edition: true,
        data: this.rowData
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      //this.loadParameterList();
      this.broadcast.broadcastEvent({
        broadcastedevent: 'resetPagination'
      });
      // reset pagination re-récupère tous les éléments
      this.resetPagination();
    });
  }

  transformData(result: any) {
    let data: any[] = [];

    for (let key in result) {
      let dataJ = result[key];
      let _data: any = {};

      _data['id'] = dataJ?.id;
      _data['Libellé'] = dataJ?.libelle;
      _data['Propriété'] = dataJ?.code;
      _data['Valeur'] = dataJ?.valeur;
      _data['Description'] = dataJ?.description;
      _data['Obligatoire'] = dataJ?.mandatory ? 'Oui' : 'Non';

      data.push(_data);
    }
    return data;
  }

  importParameterData() {
    const dialogRef = this.dialog.open(ImportParameterDataComponent, {
      width: '640px',
      disableClose: true,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
  /*loadParameterList() {
    this.parametresService
      .getParametresWithParams(environment.pagination.offset, environment.pagination.limit)
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          this.untransformedData = result;
          this.dataLength = result.length;

          this.dataJSON = result.results;

          this.dataTable = this.transformData(result.results);
        },
        error: (error) => {
        }
      });
  }*/
  updatePaginationParametres(event: any) {
    if (event) {
      this.parametresService.getParametresWithParams(event.offset, event.limit, event.filterValue).subscribe({
        next: (result: any) => {
          this.untransformedData = result.results;
          this.dataLength = result.totalRecords;

          this.dataTable = this.transformData(result.results);
          this.dataJSON = result.results;
        },
        error: (error: any) => {}
      });
    } else {
      this.parametresService
        .getParametresWithParams(environment.pagination.offset, environment.pagination.limit)
        .pipe(take(1))
        .subscribe({
          next: (result: any) => {
            this.untransformedData = result;
            this.dataLength = result.totalRecords;

            this.dataTable = this.transformData(result.results);
            this.dataJSON = result.results;
          },
          error: (error: any) => {}
        });
    }
  }
  resetPagination() {
    this.parametresService
      .getParametresWithParams(environment.pagination.offset, environment.pagination.limit)
      .pipe(take(1))
      .subscribe({
        next: (result: any) => {
          this.untransformedData = result.results;
          this.dataLength = result.totalRecords;

          this.dataTable = this.transformData(result.results);
          this.dataJSON = result.results;
        },
        error: (error: any) => {}
      });
  }
  updateFiltreParametre(value: any) {
    this.filterValue = value.filterValue;
    this.updatePaginationParametres(value);
  }
}
